module.exports = __webpack_public_path__ + "static/media/bunnygirl.35214bca.jpg";